<div class="div-carousel-container">
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content aprovado">
            <span class="nome-status">Aprovado</span>
            <span class="contador-status">{{jsonDados.aprovado}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content analise">
            <span class="nome-status">Análise</span>
            <span class="contador-status">{{jsonDados.analise}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content aguardando">
            <span class="nome-status">Aguardando</span>
            <span class="contador-status">{{jsonDados.aguardando}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content ausente">
            <span class="nome-status">Ausente</span>
            <span class="contador-status">{{jsonDados.ausente}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content divergencia">
            <span class="nome-status">Divergência</span>
            <span class="contador-status">{{jsonDados.divergencia}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content execucao">
            <span class="nome-status">Execução</span>
            <span class="contador-status">{{jsonDados.execucao}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content finalizado">
            <span class="nome-status">Finalizado</span>
            <span class="contador-status">{{jsonDados.finalizado}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content negado">
            <span class="nome-status">Negado</span>
            <span class="contador-status">{{jsonDados.negado}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content pendente_distribuicao">
            <span class="nome-status">Pen. Distribuição</span>
            <span class="contador-status">{{jsonDados.pendente_distribuicao}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content pendente">
            <span class="nome-status">Pendente</span>
            <span class="contador-status">{{jsonDados.pendente}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content perda_total">
            <span class="nome-status">Perda Total</span>
            <span class="contador-status">{{jsonDados.perda_total}}</span>
        </div>
    </div>
    <div class="div-cavalo-carousel">
        <div class="div-cavalo-carousel-content todos">
            <span class="nome-status">Todos</span>
            <span class="contador-status">{{jsonDados.todos}}</span>
        </div>
    </div>
</div>